<script>
	import Scene from './components/Scene.svelte';
	import InputField from './components/InputField.svelte';

	let sentence = 'I must not convince Devs to use Tailwind.';
	let nrOfSentences = 10;
	let fontSize = 12;

	if (window.innerWidth > 800) {
		fontSize = 23;
	}

	$: sentences = Array(nrOfSentences).fill(sentence);
</script>

<main class="max-w-[800px] mx-auto">
	<h1 class="text-white font-fuzzy-bubbles text-center mb-2 text-lg">Bart Simpson's<br>Chalkboard Generator</h1>

	<Scene {sentences} {fontSize} />
	
	<InputField bind:value={sentence} label="Sentence" />

	<div class="flex gap-4">
		<InputField classNames="flex-1" bind:value={nrOfSentences} label="Sentences" type="number" />
		<InputField classNames="flex-1" bind:value={fontSize} label="Font Size" type="number" />
	</div>
</main>

<footer class="flex flex-col mt-auto">
	<a class="mx-auto relative bg-black rounded-lg py-2 px-3 flex items-center" href="https://twitter.com/ChrizzDF" target="_black">
		<span class="inline-flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1">
			<span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
			<span class="relative inline-flex rounded-full h-3 w-3 bg-orange-500"></span>
		</span>

		<img class="mr-3 border w-8 rounded-full" src="https://pbs.twimg.com/profile_images/500255198695026688/JNTYBoq8_400x400.jpeg" alt="ChrizzDF">
		<div class="text-sm mt-0.5">
			<h3 class="text-emerald-500 font-semibold">@ChrizzDF</h3>
			<p class="text-gray-300">Follow Me!</p>
		</div>
	</a>
</footer>

<style global lang="postcss">
	@tailwind base;
	@tailwind components;
	@tailwind utilities;
</style>